import React, { useState, useEffect } from 'react';
import { styled } from '@mui/system';
import Dialog from '@mui/material/Dialog';
import DialogTitle from "@mui/material/DialogTitle";
import { toast } from 'react-toastify';
import IconButton from '@mui/material/IconButton';
import CloseIcon from '@mui/icons-material/Close';
import Typography from '@mui/material/Typography';
import { ThemeProvider, createTheme } from '@mui/material/styles'; 


const theme = createTheme();




const CheckEditDialog = (props) => {
  const [open, setOpen] = React.useState(props.editing);

  const handleClose = () => {
    setOpen(false);
  };

  const [user, setUser] = useState(props.currentUser);

  useEffect(() => {
    setUser(props.currentUser);
  }, [props]);
  // You can tell React to skip applying an effect if certain values haven’t changed between re-renders. [ props ]

  const handleInputChange = (event) => {
    const { name, value } = event.target;
    if(name==='questionType'){
      setUser({...user, [name]:value})
    }else
    {
      setUser({ ...user, [name]: value.replace(/[^\w\s]/gi, "") });
    }
  };

  return (
    <ThemeProvider theme={theme}>
    <div>
    <Dialog
          onClose={handleClose}
          aria-labelledby="customized-dialog-title"
          open={open}
          style={{}}
        >
        <DialogTitle className='MuiTgt' onClose={() => props.setEditing(false)}>
          <div className='MuiTgt'> Update Checklist Question</div>
        </DialogTitle>
        <form
          className='form-group'
          style={{ backgroundColor: '#eaf7fdcc' }}
          onSubmit={(event) => {
            event.preventDefault();

            if (user.newCategory === '') {
              toast.error('Please enter the category!!', {
                position: 'bottom-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else if (user.newSubCategory === '') {
              toast.error('Please enter the subcategory!', {
                position: 'bottom-right',
                autoClose: 2000,
                hideProgressBar: false,
                closeOnClick: true,
                pauseOnHover: true,
                draggable: true,
                progress: undefined,
              });
            } else if (
              props.checkName === 'Monthly SOD' ||
              props.checkName === 'Diagnosis - Store Handovers' ||
              props.checkName === 'Diagnosis SOD'
            ) {
              if (user.questionType === undefined || user.questionType === '') {
                toast.error('Please select the question type!', {
                  position: 'bottom-right',
                  autoClose: 2000,
                  hideProgressBar: false,
                  closeOnClick: true,
                  pauseOnHover: true,
                  draggable: true,
                  progress: undefined,
                });
              } else {
                props.updateUser(user.id, user);
              }
            } else {
              props.updateUser(user.id, user);
            }
          }}
        >
          <label for='category'>Category :</label>
          <input
            className='input-cls-select form-control'
            type='text'
            id='category'
            name='newCategory'
            value={user.newCategory}
            onChange={handleInputChange}
            maxLength="100"
            placeholder={`Add category`}
          />
          <label for='subcategory'>Subcategory :</label>
          <input
            className='input-cls-select form-control'
            type='text'
            name='newSubCategory'
            value={user.newSubCategory}
            onChange={handleInputChange}
            maxLength="100"
            placeholder={`Add subcategory`}
          />
          <label
            for='subcategory'
            style={
              props.checkName === 'Monthly SOD' ||
              props.checkName === 'Diagnosis - Store Handovers' ||
              props.checkName === 'Diagnosis SOD'
                ? { display: 'block' }
                : { display: 'none' }
            }
          >
            Question Type :
          </label>

          <select
            className='input-cls-select form-control'
            name='questionType'
            onChange={handleInputChange}
            value={user.questionType}
            style={
              props.checkName === 'Monthly SOD' ||
              props.checkName === 'Diagnosis - Store Handovers' ||
              props.checkName === 'Diagnosis SOD'
                ? { display: 'block' }
                : { display: 'none' }
            }
          >
            <option value='' selected>
              Select Question Type
            </option>
            <option value='Safety'>Safety</option>
            <option value='Image'>Image</option>
          </select>
          <label for='question'>Checklist Point :</label>
          <textarea
            type='text'
            name='name'
            id='question'
            value={user.name}
            className='input-cls '
            style={{ width: '100%' }}
            onChange={handleInputChange}
            maxLength="1000"
          />

          <button
            onClick={() => props.setEditing(false)}
            className='btn muted-button  deca-btn-orange '
            style={{ marginLeft: '56%', marginTop: '5%' }}
          >
            Cancel
          </button>

          <button
            className='btn btn-secondary deca-btn-yellow '
            style={{ marginLeft: '2%', marginTop: '5%' }}
          >
            Update Question
          </button>
        </form>
      </Dialog>
    </div>
    </ThemeProvider>
  );
};
export default CheckEditDialog;
